import { ExamCenterMemberList } from '@exam-center/admin-exam-center-member-list';
import { AddExamCenterMemberButton } from '@exam-center/exam-center-member-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamCenterMemberListPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.VIEW}>
      <PaperSection
        title='สมาชิก'
        sx={{ height: '100%' }}
        endAdornment={<AddExamCenterMemberButton />}
      >
        <Box sx={{ p: (theme) => theme.spacing(6), height: '100%' }}>
          <ExamCenterMemberList />
        </Box>
      </PaperSection>
    </PermissionGuard>
  );
}
